export const weekDays = [
  {
    label: {
      en: {
        short: 'Sun',
        long: 'Sunday',
      },
      ne: {
        short: 'आइत.',
        long: 'आइतबार',
      },
    },
    value: 0,
  },
  {
    label: {
      en: {
        short: 'Mon',
        long: 'Monday',
      },
      ne: {
        short: 'सोम.',
        long: 'सोमबार',
      },
    },
    value: 1,
  },
  {
    label: {
      en: {
        short: 'Tue',
        long: 'Tuesday',
      },
      ne: {
        short: 'मङ्गल.',
        long: 'मङ्गलबार',
      },
    },
    value: 2,
  },
  {
    label: {
      en: {
        short: 'Wed',
        long: 'Wednesday',
      },
      ne: {
        short: 'बुध.',

        long: 'बुधबार',
      },
    },
    value: 3,
  },
  {
    label: {
      en: {
        short: 'Thu',
        long: 'Thursday',
      },
      ne: {
        short: 'बिहि.',
        long: 'बिहिबार',
      },
    },
    value: 4,
  },
  {
    label: {
      en: {
        short: 'Fri',
        long: 'Friday',
      },
      ne: {
        short: 'शुक्र.',
        long: 'शुक्रबार',
      },
    },
    value: 5,
  },
  {
    label: {
      en: {
        short: 'Sat',
        long: 'Saturday',
      },
      ne: {
        short: 'शनि.',
        long: 'शनिबार',
      },
    },
    value: 6,
  },
] as const;
